import { styled } from 'Theme'

export const Title = styled.h1`
  margin-bottom: 1rem;
`
